import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon, ClockIcon } from 'lucide-react';
import { company } from '../data/company';
import { commodities } from '../data/products';
import { quickOrderMailto, whatsappLink } from '../utils/contact';
export function Footer() {
  return <footer className="border-t border-hair bg-panel" data-id="element-75" data-mp="36qhf8uj4ny17">
      <div className="mx-auto max-w-shell px-6 py-16" data-id="element-76" data-mp="3uf0phflqmkvx">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]" data-id="element-77" data-mp="3ugbpd4c2b8hr">
          <div data-id="element-78" data-mp="38z9csmx113f">
            <img src={company.logo} alt={`${company.name} logo`} className="h-16 w-auto rounded-sm border border-hair object-cover" data-id="element-79" data-mp="37ft3219eq1n" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-muted" data-id="element-80" data-mp="3qcdsl0a7m9rv">
              A Congolese mining and trading company established in {company.established} — mining,
              sourcing and exporting precious metals, copper units, rough diamonds and coloured
              gemstones to verified buyers worldwide.
            </p>
            <div className="mt-5 flex items-center gap-3" data-id="element-81" data-mp="3lbmultja1agf">
              {company.primaryCountries.map(country => <img key={country.name} src={country.flag} alt={`Flag of ${country.name}`} className="h-6 w-auto border border-hair object-cover" loading="lazy" data-id="element-82" data-mp="3v7q6vs7ueph3" />)}
              <span className="text-xs text-muted" data-id="element-83" data-mp="80nrednpyga8">
                DRC · Zambia · East Africa
              </span>
            </div>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-gold" data-id="element-84" data-mp="htd0x2zplk2x">
              CEO — {company.ceo}
            </p>
          </div>

          <div data-id="element-85" data-mp="cvtng5au5bc1">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-86" data-mp="qthxsj7a102u">
              Commodities
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-87" data-mp="mspqhvhyt597">
              {commodities.map(item => <li key={item.id} data-id="element-88" data-mp="tvw84i1avhgi">
                  <Link to="/commodities" className="text-muted transition-colors duration-150 hover:text-gold-light" data-id="element-89" data-mp="twxsxe84bibf">
                    {item.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-90" data-mp="18lbxpup3hgum">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-91" data-mp="18lu25elwv1dm">
              Company
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-92" data-mp="1hk5wnrpwejbc">
              {[{
              to: '/about',
              label: 'About & leadership'
            }, {
              to: '/live-orders',
              label: 'Live order book'
            }, {
              to: '/commodities',
              label: 'Specifications'
            }, {
              to: '/contact',
              label: 'Trading desk'
            }].map(link => <li key={link.to} data-id="element-93" data-mp="3od85lcgo84lz">
                  <Link to={link.to} className="text-muted transition-colors duration-150 hover:text-gold-light" data-id="element-94" data-mp="3t9q43uler6pv">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-95" data-mp="21ma8tfgmtfzf">
            <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-bone/60" data-id="element-96" data-mp="21nv4j8eon4yv">
              Contact
            </h2>
            <ul className="mt-5 space-y-4 text-sm text-muted" data-id="element-97" data-mp="1wpjuawkh6sg4">
              {company.offices.map(office => <li key={office.label} className="flex gap-3" data-id="element-98" data-mp="2tbvgqcxig6u0">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-99" data-mp="2pdpgzov3aril" />
                  <span data-id="element-100" data-mp="2kc02u0cklxqa">
                    <span className="block text-bone/90" data-id="element-101" data-mp="2kbgmgo2kjhed">{office.label}</span>
                    {office.lines.map(line => <span key={line} className="block" data-id="element-102" data-mp="18y4kyjua7avd">
                        {line}
                      </span>)}
                  </span>
                </li>)}
              <li className="flex gap-3" data-id="element-103" data-mp="2rvr5f9fqaecp">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-104" data-mp="2ruxxw68y3kti" />
                <a href={whatsappLink()} target="_blank" rel="noreferrer" className="transition-colors duration-150 hover:text-gold-light" data-id="element-105" data-mp="2wnhk1rlp7o9x">
                  Chat on WhatsApp
                </a>
              </li>
              <li className="flex gap-3" data-id="element-106" data-mp="3bl1n2sz1b9dg">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-107" data-mp="3bhvyrfy8cbis" />
                <a href={`mailto:${company.email}`} className="transition-colors duration-150 hover:text-gold-light" data-id="element-108" data-mp="3fj7n7i5daqpe">
                  {company.email}
                </a>
              </li>
              <li className="flex gap-3" data-id="element-109" data-mp="1q648hfee17tg">
                <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-110" data-mp="1q52lqdo0ewvw" />
                <span data-id="element-111" data-mp="1v6rxxwmyxglk">{company.hours}</span>
              </li>
            </ul>
            <a href={quickOrderMailto()} className="mt-6 inline-block rounded-sm border border-gold px-4 py-2.5 text-sm font-semibold text-gold-light transition-colors duration-150 hover:bg-gold hover:text-ink" data-id="element-112" data-mp="1nkmr0g6j0v8l">
              Place an Order
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-hair pt-6 text-xs text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-113" data-mp="1rocfl5n7bctm">
          <p data-id="element-114" data-mp="zwwrt89wrk1t">
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </p>
          <p className="font-mono uppercase tracking-[0.16em]" data-id="element-115" data-mp="1do1k1pay5a24">
            ITSCI member · Kimberley Process · LME Grade A supply
          </p>
        </div>
      </div>
    </footer>;
}